import cutaquig from './cutaquig';
import fibryga from './fibryga';
import nuwiq from './nuwiq';
import octagam from './octagam';
import panzyga from './panzyga';
import wilate from './wilate';

export default {
  nuwiq,
  wilate,
  fibryga,
  octagam,
  cutaquig,
  panzyga,
};
